var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, PCSS, Defaults, ViewChild, Watch, PropertyConverters, Utils, Components, PropertyChangeEventName, Logging, Animations, UI } from '@pacem/pacem-core';
import { RenderableEvent, DragEvent, RenderableElement } from './types';
import { TAG_MIDDLE_NAME } from './constants';
//namespace Pacem.Components.Drawing3D {
let Pacem3DElement = class Pacem3DElement extends Components.PacemItemsContainerElement {
    constructor() {
        super(...arguments);
        this._itemPropertyChangeHandler = (evt) => {
            const renderable = evt.target;
            // clear flags
            // TODO: be more precise
            this.adapter &&
                this.adapter.updateItem(this, renderable);
            renderable.flags.splice(0);
        };
        this._clickHandler = (evt) => {
            let me = this;
            if (!me.interactive || Utils.isNull(me._lastHitResult)) {
                return;
            }
            const type = evt.type.replace(/^mouse/, '');
            const hit = me._lastHitResult, object = hit.object, point = hit.point;
            this._itemDispatch(object, point, type, evt);
        };
        this._hitTestCallback = (result, evt) => {
            const me = this;
            // TODO: handle dragging
            if (result != me._lastHitResult) {
                if (result?.object != me._lastHitResult?.object) {
                    const obj = result?.object, last = me._lastHitResult?.object, pt = result?.point;
                    if (!Utils.isNull(last)) {
                        this._itemDispatch(last, pt, 'out', evt);
                    }
                    if (!Utils.isNull(obj)) {
                        this._itemDispatch(obj, pt, 'over', evt);
                    }
                }
                me._lastHitResult = result;
            }
        };
        this._moveHandler = (evt) => {
            let me = this;
            if (!me.adapter || !me.interactive) {
                return;
            }
            const rect = me._resizer.currentSize;
            const callback = (r) => me._hitTestCallback(r, evt);
            const pixel = evt.type === 'mousemove' ? { x: evt.pageX - rect.left, y: evt.pageY - rect.top } : { x: -1, y: -1 };
            me.adapter.raycast(this, pixel, rect, callback);
        };
        this._resizeHandler = (evt) => {
            const oldSize = this.#size;
            const size = evt.detail;
            if (!Utils.isNull(oldSize) && oldSize.height === size.height && oldSize.width === size.width) {
                return;
            }
            this.#size = size;
            const adapter = this.adapter;
            if (!Utils.isNull(adapter)) {
                this.adapter.invalidateSize(this, size);
                this.dispatchEvent(new Components.ResizeEvent(size));
            }
        };
        //#endregion
    }
    validate(item) {
        return item instanceof RenderableElement;
    }
    get stage() {
        return this._container;
    }
    get scene() {
        return this.adapter && this.adapter.getScene(this);
    }
    register(item) {
        const retval = super.register(item);
        if (retval) {
            this._add(item);
            item.addEventListener(PropertyChangeEventName, this._itemPropertyChangeHandler, false);
        }
        return retval;
    }
    unregister(item) {
        const retval = super.unregister(item);
        if (retval) {
            item.removeEventListener(PropertyChangeEventName, this._itemPropertyChangeHandler, false);
            this._erase(item);
        }
        return retval;
    }
    _refreshDatasource(val = this.datasource) {
        this.adapter?.updateItem(this, undefined);
    }
    _buildUpDatasourceFromDOM(val = this.items) {
        if (!Utils.isNullOrEmpty(val)) {
            this.datasource = val.slice();
        }
    }
    _add(item) {
        this.adapter &&
            this.adapter.addItem(this, item);
    }
    _erase(item) {
        this.adapter &&
            this.adapter.removeItem(this, item);
    }
    _initializeAdapter(old, val) {
        return new Promise((resolve, reject) => {
            const items = this.datasource || [];
            if (!Utils.isNull(old)) {
                items.forEach(i => old.removeItem(this, i));
            }
            if (!Utils.isNull(this._container) && !Utils.isNull(val)) {
                val.initialize(this).then(_ => {
                    (items || []).forEach(i => this._add(i));
                    resolve();
                }, e => {
                    this.log(Logging.LogLevel.Error, e?.toString());
                    reject(e);
                });
            }
            else {
                resolve();
            }
        });
    }
    //#region lifecycle
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (first) {
            return;
        }
        switch (name) {
            case 'adapter':
                this._initializeAdapter(old, val);
                break;
            case 'items':
                this._buildUpDatasourceFromDOM(val);
                break;
            case 'transparent':
                this.adapter?.invalidateSize(this, this.size);
                break;
            case 'datasource':
                this._refreshDatasource(val);
            case 'disabled':
            case 'background':
                this.render();
                break;
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        // stage
        const container = this._container;
        // resizer
        const resizer = this._resizer;
        resizer.addEventListener('resize', this._resizeHandler, false);
        resizer.target = container;
        // adapter
        this._initializeAdapter(null, this.adapter).then(_ => {
            container.addEventListener('mousemove', this._moveHandler, false);
            container.addEventListener('click', this._clickHandler, false);
            container.addEventListener('mouseup', this._clickHandler, false);
            container.addEventListener('mousedown', this._clickHandler, false);
            container.addEventListener('mouseout', this._moveHandler, false);
            this._buildUpDatasourceFromDOM();
            this.render();
        });
    }
    _itemDispatch(target, point, type, offset) {
        if (!Utils.isNull(target)) {
            var dragArgs, originalEvent, evtType;
            if (offset instanceof Event) {
                originalEvent = offset;
            }
            else {
                dragArgs = { item: target, offset: offset };
            }
            if (typeof type === 'string') {
                evtType = type;
            }
            else {
                evtType = type.type;
                originalEvent = type.originalEvent;
            }
            const m = point;
            const evt = () => offset instanceof Event ? new RenderableEvent(evtType, target, originalEvent, m) : new DragEvent(evtType, { detail: dragArgs, cancelable: evtType === UI.DragDropEventType.Init || evtType === UI.DragDropEventType.Drag }, originalEvent, m), itemevt = offset instanceof Event ? new RenderableEvent('item' + evtType, target, originalEvent, m) : new DragEvent('item' + evtType, { detail: dragArgs, cancelable: evtType === UI.DragDropEventType.Init || evtType === UI.DragDropEventType.Drag }, originalEvent, m);
            var prevent = false;
            if (target instanceof EventTarget) {
                const evnt = evt();
                target.dispatchEvent(evnt);
                prevent = evnt.defaultPrevented;
            }
            target.stage.dispatchEvent(itemevt);
            // was the event (in one of its forms) rejected?
            return prevent || itemevt.defaultPrevented;
        }
        return false;
    }
    disconnectedCallback() {
        this.#handle?.stop();
        const resizer = this._resizer, container = this._container;
        if (!Utils.isNull(container)) {
            container.removeEventListener('click', this._clickHandler, false);
            container.removeEventListener('mouseup', this._clickHandler, false);
            container.removeEventListener('mousedown', this._clickHandler, false);
            container.removeEventListener('mousemove', this._moveHandler, false);
            container.removeEventListener('mouseout', this._moveHandler, false);
        }
        if (!Utils.isNull(resizer)) {
            resizer.removeEventListener('resize', this._resizeHandler, false);
        }
        super.disconnectedCallback();
    }
    #size;
    get size() {
        return this.#size;
    }
    render(item, deepUpdate, now = performance.now()) {
        if (!Utils.isNull(item)) {
            const adapter = this.adapter;
            if (!Utils.isNull(adapter)) {
                adapter.updateItem(this, item);
            }
        }
        else {
            this.#handle?.stop();
            this.#handle = Animations.Timer.run(_ => this._doRender());
            //this._doRender();
        }
    }
    #handle;
    _doRender() {
        if (!this.disabled && !Utils.isNull(this.adapter)) {
            const scene = this.adapter.getScene(this);
            let cancelable = new CustomEvent('prerender', { detail: { scene }, cancelable: true });
            this.dispatchEvent(cancelable);
            if (!cancelable.defaultPrevented) {
                this.adapter.render(this);
                this.dispatchEvent(new CustomEvent('render', { detail: { scene } }));
            }
        }
    }
};
__decorate([
    ViewChild(`.${PCSS}-3d`)
], Pacem3DElement.prototype, "_container", void 0);
__decorate([
    ViewChild(P + '-resize')
], Pacem3DElement.prototype, "_resizer", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], Pacem3DElement.prototype, "interactive", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], Pacem3DElement.prototype, "transparent", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], Pacem3DElement.prototype, "background", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Element })
], Pacem3DElement.prototype, "adapter", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Json })
], Pacem3DElement.prototype, "datasource", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], Pacem3DElement.prototype, "orbit", void 0);
Pacem3DElement = __decorate([
    CustomElement({
        tagName: P + '-' + TAG_MIDDLE_NAME, shadow: Defaults.USE_SHADOW_ROOT, template: `<${P}-resize watch-position="true"></${P}-resize><div class="${PCSS}-3d"></div><${P}-content></${P}-content>`
    })
], Pacem3DElement);
export { Pacem3DElement };
